import {
    getCategories,
    getItemCategoryName,
    getItemSubscriptionFrequency,
    getQuantity
} from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/mapping/functions'
import { MappingItem } from '@corratech/pylot-gtm/src/GTM'

export const pdpCartItemMapping = (
    categoryItems = getCategories
): MappingItem => {
    return {
        id: [['product', 'sku']],
        name: [['product', 'name']],
        currency: ['prices', 'row_total_including_tax', 'currency'],
        discount: ['prices', 'total_item_discount', 'value'],
        brand: ['product', 'brand_text'],
        category: categoryItems,
        item_category: getItemCategoryName,
        price: ['prices', 'price', 'value'],
        quantity: getQuantity,
        subscription_frequency: getItemSubscriptionFrequency
    }
}
